export function formatNumberFixed(value: number) {
  return Number(value)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

export function formatNumber(value: number | string) {
  return value.toString().replace(/\d(?=(\d{3})+$)/g, '$&,')
}
